import {ComponentData} from "../../engine/tools/EntityManager";

export class PumpSpeed implements ComponentData {

    speed: number = 1

    constructor(options?: Partial<PumpSpeed>) {
        Object.assign(this, options)
    }
}